/**
 * @name responsive-base
 * @description Core responsive-bae provider in ngx-responsive
 *
 * @license MIT
 */
export * from './responsive-base';
